import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isLogin } from '../utils';

const CheckLogin = ({ component: Component, ...rest }) => {
    console.log('CheckLogin - isLogin():', isLogin());
    console.log('CheckLogin - current path:', window.location.pathname);
    
    return (
        <Route {...rest} render={props => {
            console.log('CheckLogin render - path:', props.location.pathname);
            if (isLogin()) {
                console.log('CheckLogin - user is logged in, redirecting to dashboard');
                return <Redirect to="/dashboard" />;
            } else {
                console.log('CheckLogin - user is not logged in, redirecting to login');
                return <Redirect to="/login" />;
            }
        }} />
    );
};

export default CheckLogin;